var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import { ConfigProvider } from "../hooks/useConfig";
import i18n from "../strings";
var DefaultProviders = function (_a) {
    var config = _a.config, children = _a.children;
    useEffect(function () {
        i18n.changeLanguage(config.lang);
    }, [config.lang]);
    return (_jsx(ConfigProvider, __assign({ value: config }, { children: _jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: children })) })) })));
};
export default DefaultProviders;
